export default __webpack_public_path__ + "static/media/contact.d614dca6.svg";